import { v4 as uuidv4 } from 'uuid';
import { DueAfter } from '@/entities/issueTemplate';

export interface ChecklistTemplateEditable {
  id?: number;
  checklistId: number | null;
  title: string;
  assignees: Array<number | string>;
  assignedGroups: Array<number | string>;
  dueIn: null | DueAfter;
  internalId: string;
  wasChanged: boolean;
  softDeleted: boolean;
}

export const emptyChecklistTemplate = (): ChecklistTemplateEditable => ({
  checklistId: null,
  title: '',
  assignees: [],
  assignedGroups: [],
  dueIn: {
    weeks: 1,
    days: null,
    hours: null,
    minutes: null,
  },
  internalId: uuidv4(),
  wasChanged: false,
  softDeleted: false,
});
